import {Ref, watch} from 'vue';
import useUa from '@/hooks/useUa';
import {enableIOSGesture} from '@/bridge';

// android 支持弹窗类组件按键返回
export const usePopReturn = (isShow: Ref<boolean>, hidePop: () => void) => {
  const {isIOS} = useUa();// ios 不能按键返回, 但要在弹窗时禁用手势

  watch(isShow, () => {
    if (isIOS) {
      return;
    }
    if (isShow.value) {// 弹窗显示, 增加 # 标记
      window.history.pushState({}, '', '#');
    }
    else if (!isShow.value && window.location.href.includes('#')) {// 弹窗隐藏并且当前包含 # 执行 back
      window.history.back();
    }
  });

  const handlePopState = () => {
    if (isShow.value) {// 监听到 popstate 事件后, 先判断弹窗是否正在显示, 是就隐藏弹窗
      hidePop();
    }
  };

  const handleOpen = () => {
    if (isIOS) {
      enableIOSGesture(0, 0);// 禁用手势
      return;
    }

    window.addEventListener('popstate', handlePopState); // 监听 popstate 事件
  };

  const handleClose = () => {
    if (isIOS) {
      enableIOSGesture(1, 1);// 启用手势
      return;
    }

    window.removeEventListener('popstate', handlePopState);
  };

  return {handleOpen, handleClose};
};
